<template lang="pug">
div
  .promotion-single(v-if="target === 1")
    .promotion-banner
      img.img-fluid(src='img/promotion/welcome_slot.jpg')
    .promotion-detail.d-flex.justify-content-center.flex-column
      .promotion-title-big {{ $t('ui.promo_text.promo1.title')}}
      .promotion-title-small
      .promotion-period
        //.promotion-period-left Time left:
        //.promotion-period-right 12days 3hour 45min
      //- a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#modal-promotion01')
      a(href="javascript:void(0)" @click="openModal('#modal-promotion01')")
        .btn-main.btn-promotion
          .btn-promotion-text {{ $t('ui.more_info') }}
          .btn-promotion-icon
            img(src='img/icon-info.svg')
  .promotion-single(v-if="target === 2")
    .promotion-banner
      img.img-fluid(src='img/promotion/xmas.jpg')
    .promotion-detail.d-flex.justify-content-center.flex-column
      .promotion-title-big {{$t('ui.promo_text.promo2.title')}}
      .promotion-title-small 
      .promotion-period
        //.promotion-period-left Time left:
        //.promotion-period-right 12days 3hour 45min
      //- a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#modal-promotion02')
      a(href="javascript:void(0)" @click="openModal('#modal-promotion02')")
        .btn-main.btn-promotion
          .btn-promotion-text {{ $t('ui.more_info') }}
          .btn-promotion-icon
            img(src='img/icon-info.svg')
  .promotion-single(v-if="target === 3")
    .promotion-banner
      img.img-fluid(src='img/promotion/regular.jpg')
    .promotion-detail.d-flex.justify-content-center.flex-column
      .promotion-title-big {{$t('ui.promo_text.promo3.title')}}
      .promotion-title-small 
      .promotion-period
        //.promotion-period-left Time left:
        //.promotion-period-right 12days 3hour 45min
      //- a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#modal-promotion03')
      a(href="javascript:void(0)" @click="openModal('#modal-promotion03')")
        .btn-main.btn-promotion
          .btn-promotion-text {{ $t('ui.more_info') }}
          .btn-promotion-icon
            img(src='img/icon-info.svg')
  .promotion-single(v-if="target === 4")
    .promotion-banner
      img.img-fluid(src='img/promotion/freecredit.jpg')
    .promotion-detail.d-flex.justify-content-center.flex-column
      .promotion-title-big {{$t('ui.promo_text.promo4.title')}}
      .promotion-title-small 
      .promotion-period
        //.promotion-period-left Time left:
        //.promotion-period-right 12days 3hour 45min
      //- a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#modal-promotion04')
      a(href="javascript:void(0)" @click="openModal('#modal-promotion04')")
        .btn-main.btn-promotion
          .btn-promotion-text {{ $t('ui.more_info') }}
          .btn-promotion-icon
            img(src='img/icon-info.svg')
  .promotion-single(v-if="target === 5")
    .promotion-banner
      img.img-fluid(src='img/promotion/daily.jpg')
    .promotion-detail.d-flex.justify-content-center.flex-column
      .promotion-title-big {{$t('ui.promo_text.promo5.title')}}
      .promotion-title-small 
      .promotion-period
        //.promotion-period-left Time left:
        //.promotion-period-right 12days 3hour 45min
      //- a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#modal-promotion05')
      a(href="javascript:void(0)" @click="openModal('#modal-promotion05')")
        .btn-main.btn-promotion
          .btn-promotion-text {{ $t('ui.more_info') }}
          .btn-promotion-icon
            img(src='img/icon-info.svg')
  .promotion-single(v-if="target === 6")
    .promotion-banner
      img.img-fluid(src='img/promotion/casino.jpg')
    .promotion-detail.d-flex.justify-content-center.flex-column
      .promotion-title-big {{$t('ui.promo_text.promo6.title')}}
      .promotion-title-small 
      .promotion-period
        //.promotion-period-left Time left:
        //.promotion-period-right 12days 3hour 45min
      //- a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#modal-promotion06')
      a(href="javascript:void(0)" @click="openModal('#modal-promotion06')")
        .btn-main.btn-promotion
          .btn-promotion-text {{ $t('ui.more_info') }}
          .btn-promotion-icon
            img(src='img/icon-info.svg')
  .promotion-single(v-if="target === 7")
    .promotion-banner
      img.img-fluid(src='img/promotion/referral.jpg')
    .promotion-detail.d-flex.justify-content-center.flex-column
      .promotion-title-big {{$t('ui.promo_text.promo7.title')}}
      .promotion-title-small 
      .promotion-period
        //.promotion-period-left Time left:
        //.promotion-period-right 12days 3hour 45min
      //- a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#modal-promotion07')
      a(href="javascript:void(0)" @click="openModal('#modal-promotion07')")
        .btn-main.btn-promotion
          .btn-promotion-text {{ $t('ui.more_info') }}
          .btn-promotion-icon
            img(src='img/icon-info.svg')
  .promotion-single(v-if="target === 8")
    .promotion-banner
      img.img-fluid(src='img/promotion/weekly-sb.jpg')
    .promotion-detail.d-flex.justify-content-center.flex-column
      .promotion-title-big {{$t('ui.promo_text.promo8.title')}}
      .promotion-title-small 
      .promotion-period
        //.promotion-period-left Time left:
        //.promotion-period-right 12days 3hour 45min
      //- a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#modal-promotion08')
      a(href="javascript:void(0)" @click="openModal('#modal-promotion08')")
        .btn-main.btn-promotion
          .btn-promotion-text {{ $t('ui.more_info') }}
          .btn-promotion-icon
            img(src='img/icon-info.svg')
  .promotion-single(v-if="target === 9")
    .promotion-banner
      img.img-fluid(src='img/promotion/Extra-Bonus-Freespin.jpg')
    .promotion-detail.d-flex.justify-content-center.flex-column
      .promotion-title-big {{$t('ui.promo_text.promo9.title')}}
      .promotion-title-small {{$t('ui.promo_text.promo9.title2')}}
      .promotion-title-small {{$t('ui.promo_text.promo9.title3')}}
      .promotion-period
        //.promotion-period-left Time left:
        //.promotion-period-right 12days 3hour 45min
      //- a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#modal-promotion09')
      a(href="javascript:void(0)" @click="openModal('#modal-promotion09')")
        .btn-main.btn-promotion
          .btn-promotion-text {{ $t('ui.more_info') }}
          .btn-promotion-icon
            img(src='img/icon-info.svg')
  .promotion-single(v-if="target === 10")
    .promotion-banner
      img.img-fluid(src='img/promotion/Event-Bola-Petir.jpg')
    .promotion-detail.d-flex.justify-content-center.flex-column
      .promotion-title-big {{$t('ui.promo_text.promo10.title')}}
      .promotion-title-small 
      .promotion-period
        //.promotion-period-left Time left:
        //.promotion-period-right 12days 3hour 45min
      //- a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#modal-promotion10')
      a(href="javascript:void(0)" @click="openModal('#modal-promotion10')")
        .btn-main.btn-promotion
          .btn-promotion-text {{ $t('ui.more_info') }}
          .btn-promotion-icon
            img(src='img/icon-info.svg')
  .promotion-single(v-if="target === 11")
    .promotion-banner
      img.img-fluid(src='img/promotion/Garansi-Kekalahan-Beruntun.jpg')
    .promotion-detail.d-flex.justify-content-center.flex-column
      .promotion-title-big {{$t('ui.promo_text.promo11.title')}}
      .promotion-title-small {{$t('ui.promo_text.promo11.title2')}}
      .promotion-period
        //.promotion-period-left Time left:
        //.promotion-period-right 12days 3hour 45min
      //- a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#modal-promotion11')
      a(href="javascript:void(0)" @click="openModal('#modal-promotion11')")
        .btn-main.btn-promotion
          .btn-promotion-text {{ $t('ui.more_info') }}
          .btn-promotion-icon
            img(src='img/icon-info.svg')
</template>
<script>
export default {
  props: {
    target: {
      type: Number,
      default: false
    },
  },
  methods:{
    openModal(target){
      $(target).modal('show')
    }
  }
}
</script>
<style lang="scss" scoped>
@media(min-width: 992px){
  .promotion-banner img {
    min-height: 242px;
}
}
</style>